import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Heart } from "lucide-react";
import Seo from "@/components/Seo";

export default function Wishlist() {
  const { user, loading } = useAuth();
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!user) return;
    api.wishlist.get().then((data) => setItems(data.items || []));
  }, [user]);

  if (loading) return <div className="mx-auto max-w-4xl px-4 py-24 text-center text-[var(--yp-muted)]">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="mx-auto max-w-6xl px-4 py-10 md:py-14">
      <Seo title="Wishlist" path="/wishlist" noindex={true} />
      <div className="text-xs uppercase tracking-widest text-[var(--yp-muted)]">Saved plants</div>
      <h1 className="font-serif-display text-3xl md:text-4xl text-[var(--yp-primary)]">Your wishlist</h1>
      {items.length === 0 ? (
        <div className="mt-10 text-center bg-[var(--yp-surface-alt)] rounded-2xl p-12">
          <Heart size={40} className="mx-auto text-[var(--yp-primary)]" />
          <div className="mt-4 text-[var(--yp-muted)]">No saved plants yet</div>
          <Link to="/shop" className="mt-4 inline-block btn-primary rounded-full px-6 py-2.5 text-sm">Explore plants</Link>
        </div>
      ) : (
        <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {items.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
